import * as React from 'react';
import {FunctionComponent} from 'react';
import {Link} from 'react-router-dom';
import {classNames} from '../../../Support/classNames';

interface OwnProps {
    className?: string;
}

export const BrowseWorkouts: FunctionComponent<OwnProps> = ({className}) => {
    return (
        <div className={classNames(className, 'card')}>
            <div className="card-title">
                <h5>Add workouts</h5>
            </div>
            <div className="card-body d-flex flex-column">
                <p>
                    Build your report by adding workouts. You can also include workouts from your{' '}
                    <Link to="/crews">crewmates</Link>.
                </p>
                <Link to="/workouts" className="btn-primary btn">
                    Browse Workouts
                </Link>
            </div>
        </div>
    );
};
